import ArchivedBatch from "../../../../../../Models/ArchivedBatch";
import ArchivedSpecimen from "../../../../../../Models/ArchivedSpecimen";
import ArchivedPatient from "../../../../../../Models/ArchivedPatient";
import ArchivedCompWellnessPatient from "../../../../../../Models/ArchivedCompWellnessPatient";
import BatchReportData from '../../../../../../Models/BatchReportData';
import WellType from "../../../../../../Models/WellType";

export const GeneratePanelData = (batch: ArchivedBatch, specimens: ArchivedSpecimen[], lumiPatients: ArchivedPatient[], compWellnessPatients: ArchivedCompWellnessPatient[]): BatchReportData[] => {
    var result: BatchReportData[] = [];

    batch.specimens.forEach(batchSpecimen => {
        let lumiRegex = new RegExp("LU[ABCDEFGHJKLMNPQRTUVWXYZ2346789]{6}");
        let compWellnessRegex = new RegExp("((PN|MD|US|VE)[ABCDEFGHJKLMNPQRTUVWXYZ2346789]{6}|VIP[ABCDEFGHJKLMNPQRTUVWXYZ2346789]{5})");
        var specimen = null;
        var lumiPatient = null;
        var compWellnessPatient = null;

        if (!lumiRegex.test(batchSpecimen.specimenId)) {
            specimen = specimens.find(spec => batchSpecimen.specimenId === spec.specimenId);
        }

        if (lumiRegex.test(batchSpecimen.specimenId) && specimen === null) {
            lumiPatient = lumiPatients.find(patient => patient.sampleId === batchSpecimen.specimenId);
        }

        if (compWellnessRegex.test(batchSpecimen.specimenId) && specimen === null) {
            compWellnessPatient = compWellnessPatients.find(patient => patient.kitNumber === batchSpecimen.specimenId);
        }

        if (specimen === null && lumiPatient === null && compWellnessPatient === null) {
            var message = `Specimen ID ${batchSpecimen.specimenId} is found in archived batch ${batch.name} but cannot be found in list of archived specimens`;
            alert(message); // Very spammy when things are wrong, just going to console.error this instead
            console.error(message);
            return [];
        }

        if (specimen) {
            result.push({
                wellNumber: batchSpecimen.wellNumber,
                wellType: WellType.STANDARD,
                specimen: specimen
            });
        } else if (lumiPatient) {
            result.push({
                wellNumber: batchSpecimen.wellNumber,
                wellType: WellType.STANDARD,
                lumiPatient: lumiPatient
            });
        } else if (compWellnessPatient) {
            result.push({
                wellNumber: batchSpecimen.wellNumber,
                wellType: WellType.STANDARD,
                compWellnessPatient: compWellnessPatient
            });
        }
    })

    return result;
}